interface HeroProps {
  query: string;
  onQueryChange: (v: string) => void;
}

export default function Hero({ query, onQueryChange }: HeroProps) {
  return (
    <section id="top" className="relative overflow-hidden pt-16">
      <div className="absolute inset-0 -z-10">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20warm%20manga%20cityscape%20illustration%20at%20golden%20hour%2C%20dynamic%20comic%20panels%20with%20heroes%20and%20energy%20blasts%2C%20coral%20orange%20and%20amber%20palette%2C%20bold%20outlined%20cartoon%20style%2C%20cinematic%20wide%20shot%2C%20soft%20sunlight%20through%20clouds%2C%20vibrant%20semi%20flat%20illustration%20with%20clean%20shapes%2C%20high%20detail%20artwork&width=1600&height=900&seq=hero-bg-manga&orientation=landscape"
          alt="喵趣漫画网 热血漫画插画背景"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/80 via-background-50/70 to-background-50"></div>
      </div>

      <div className="mx-auto flex w-full max-w-[1200px] flex-col items-center px-4 pb-16 pt-12 text-center md:px-6 md:pb-24 md:pt-20">
        <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-xs font-semibold text-accent-800">
          <i className="ri-fire-fill text-accent-500"></i>
          每日更新 · 已上线 3800+ 部作品
        </span>

        <h1 className="mt-6 font-heading text-4xl leading-tight text-foreground-950 sm:text-5xl md:text-6xl">
          喵趣漫画网
        </h1>
        <p className="mt-4 text-lg font-bold text-primary-600 sm:text-2xl">
          汉化连载 · 独家翻译 · 抢先看
        </p>
        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-700 sm:text-base">
          未删减高清原版，与热门作品同步更新。原汁原味、不阉割的漫画，来喵趣漫画网就对了。
        </p>

        <form
          className="mt-8 flex w-full max-w-xl flex-col gap-3 sm:flex-row"
          onSubmit={(e) => {
            e.preventDefault();
            document.getElementById('featured')?.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          <div className="relative flex-1">
            <i className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-foreground-500"></i>
            <input
              type="text"
              value={query}
              onChange={(e) => onQueryChange(e.target.value)}
              placeholder="搜索作品名或题材，如：燃魂少年"
              className="h-12 w-full rounded-full border border-background-300 bg-background-50 pl-11 pr-4 text-sm text-foreground-950 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
            />
          </div>
          <button
            type="submit"
            className="inline-flex h-12 shrink-0 items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-search-line mr-2 text-base"></i>
            搜索追更
          </button>
        </form>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <a
            href="#featured"
            className="inline-flex items-center whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-bookmark-fill mr-2 text-base"></i>
            立即开始追更
          </a>
          <a
            href="#rank"
            className="inline-flex items-center whitespace-nowrap rounded-full border border-primary-200 bg-background-50/70 px-6 py-3 text-sm font-semibold text-primary-700 transition-colors hover:border-primary-300 hover:bg-primary-50"
          >
            <i className="ri-trophy-line mr-2 text-base"></i>
            本周更新榜
          </a>
        </div>

        <dl className="mt-12 grid w-full max-w-3xl grid-cols-2 gap-4 sm:grid-cols-4">
          {[
            { value: '3800+', label: '连载作品' },
            { value: '2400+', label: '独家汉化' },
            { value: '99.2%', label: '同步及时率' },
            { value: '800万+', label: '人气读者' },
          ].map((s) => (
            <div key={s.label} className="rounded-2xl border border-background-200 bg-background-50/70 p-4">
              <dt className="order-2 mt-1 text-xs text-foreground-600">{s.label}</dt>
              <dd className="font-heading text-2xl text-accent-600">{s.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}